import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskEmail'
})
export class MaskEmailPipe implements PipeTransform {
  transform(email: string): string {
    if (!email || !email.includes('@')) {
      return email; // Return the original email if invalid
    }

    const [localPart, domain] = email.split('@');
    const maskedLocalPart = localPart.charAt(0) + '***' + localPart.charAt(localPart.length - 1);
    return `${maskedLocalPart}@${domain}`;
  }
}